import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import SubscriptionCategoryTable from '@modules/subscriptions/components/tables/subscription-category-table/subscription-category-table.vue';

@Component({
  name: 'bpc-subscription-categories',
  components: {
    'bpc-subscription-category-table': SubscriptionCategoryTable,
  },
})
export default class SubscriptionCategory extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
